(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-custom-property"] && !Shopify.designMode) return;
  try {
    const syncPersonalizationFields = (root) => {
    const control = root.querySelector('[data-personalization-choice]');
    const fields = root.querySelector('[data-personalization-fields]');
    if (!control || !fields) return;

    if (control.dataset.personalizationChoice === 'text') {
      const isCustom = control.value === 'Custom name';
      fields.hidden = !isCustom;
      fields.querySelectorAll('input, textarea').forEach((input) => {
        input.disabled = !isCustom;
        input.required = isCustom && input.dataset.required === 'true';
        if (!isCustom) input.value = '';
      });
      return;
    }

    const imageCount = Number(control.value);
    fields.hidden = imageCount === 0;
    fields.querySelectorAll('[data-upload-slot]').forEach((slot) => {
      const input = slot.querySelector('input[type="file"]');
      const isActive = Number(slot.dataset.uploadSlot) <= imageCount;
      slot.hidden = !isActive;
      input.disabled = !isActive;
      input.required = isActive && input.dataset.required === 'true';
      if (!isActive) input.value = '';
    });
  };

  const initializePersonalizationFields = (scope = document) => {
    scope.querySelectorAll('product-custom-property-component').forEach(syncPersonalizationFields);
  };

  document.addEventListener('change', (event) => {
    const control = event.target.closest('[data-personalization-choice]');
    if (!control) return;
    syncPersonalizationFields(control.closest('product-custom-property-component'));
  });

  document.addEventListener('shopify:section:load', (event) => initializePersonalizationFields(event.target));
  initializePersonalizationFields();
  } catch(e) { console.error(e); }
})();

})();
